import { render, staticRenderFns } from "./DialogFrame2.vue?vue&type=template&id=55ecd6e1&scoped=true"
import script from "./DialogFrame2.vue?vue&type=script&lang=js"
export * from "./DialogFrame2.vue?vue&type=script&lang=js"
import style0 from "./DialogFrame2.vue?vue&type=style&index=0&id=55ecd6e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecd6e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ecd6e1')) {
      api.createRecord('55ecd6e1', component.options)
    } else {
      api.reload('55ecd6e1', component.options)
    }
    module.hot.accept("./DialogFrame2.vue?vue&type=template&id=55ecd6e1&scoped=true", function () {
      api.rerender('55ecd6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogFrame2.vue"
export default component.exports